export default "__VITE_ASSET__DnePD$Up__"